import axios from "axios";
import AuthService from "./AuthService";
import ClienteDto from "../../modules/dto/ClienteDto";

class ClienteService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com";
    }

    // Mï¿½todo para obter a razï¿½o social do cliente
    async getRazaoSocial(cdCliente) {
        try {
            // Verifica se o token jï¿½ foi obtido, se nï¿½o, faz o login
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/cliente/razao-social/${cdCliente}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`, // Usa o token armazenado
                    },
                }
            );
            //console.log(response);
            return response.data.conteudo;
        } catch (error) {
            console.error("Erro ao buscar a razão social:", error);
            throw new Error("Erro ao buscar a razão social.");
        }
    }

    async getDadosCliente(cdCliente) {
        try {
            console.log('👤 ClienteService: Buscando dados do cliente:', cdCliente);
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/cliente/dados-cliente/${cdCliente}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                }
            );
            console.log('👤 ClienteService: Resposta da API:', response.data);
            // Verifica se a resposta está correta
            if (response.data.status === "OK" && response.data.conteudo) {
                // Mapeia a resposta para a classe ClienteDTO
                const cliente = new ClienteDto(response.data.conteudo);
                console.log('👤 ClienteService: Cliente mapeado:', cliente);
                console.log('👤 ClienteService: Emails do cliente:', cliente.emails);
                return cliente; // Retorna o objeto ClienteDTO
            } else {
                throw new Error(
                    "Erro ao buscar dados do cliente: " + response.data.mensagem
                );
            }
        } catch (error) {
            console.error("Erro ao buscar os dados do cliente:", error);
            throw new Error("Erro ao buscar os dados do cliente.");
        }
    }

    async getListarNotificacao(cdCliente) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.get(
                `${this.apiUrl}/notificacao/listar/${cdCliente}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                }
            );

            if (
                response.data.status === "OK" &&
                response.data.conteudo &&
                Array.isArray(response.data.conteudo)
            ) {
                const notificacoes = response.data.conteudo.map(
                    (notificacao) => ({
                        tipoNotificacao: notificacao.tipoNotificacao,
                        dsNotificacao: notificacao.dsNotificacao,
                    })
                );

                return notificacoes; // Retorna a lista de notifica��es
            } else {
                throw new Error(
                    "Erro ao buscar dados de notifica��o: " +
                    response.data.mensagem
                );
            }
        } catch (error) {
            console.error("Erro ao buscar dados de notifica��o", error);
            throw new Error("Erro ao buscar dados de notifica��o.");
        }
    }
}

export default new ClienteService();
